import { ReactNode } from 'react';
import { BASE_ROUTES } from 'core/common/constants';
import { useRouter } from 'core/common/hooks';
import { Button } from 'core/common/ui/ui-kit';
import { IconStyled, SupportBotWrapperStyled } from './styled';

type SupportBotButtonProps = {
  className?: string;
  buttonText?: ReactNode;
  variant?: 'fixed' | 'static';
};

export const SupportBotButton = ({
  className = '',
  buttonText,
  variant = 'static',
}: SupportBotButtonProps) => {
  const { navigate } = useRouter();

  const handleClick = () => {
    navigate(BASE_ROUTES.TECH_CONTACT_US);
  };

  return (
    <SupportBotWrapperStyled variant={variant} className={className}>
      <Button
        startIcon={<IconStyled name="question-circled" width={20} height={20} />}
        onClick={handleClick}
        size="small"
        variant="contained"
      >
        {buttonText}
      </Button>
    </SupportBotWrapperStyled>
  );
};
